import { Synchronized } from '#common/util';
import { parseWasmResult } from '#wasm/common';
export class FilespaceWasm extends Synchronized {
    mod;
    constructor(mod, mutex) {
        super(mutex);
        this.mod = mod;
    }
    link(linkParams) {
        return this.mutex.runExclusive(async () => {
            parseWasmResult(await this.mod.LinkFilespace(linkParams));
        });
    }
    unlink() {
        return this.mutex.runExclusive(async () => {
            parseWasmResult(await this.mod.UnlinkFilespace());
        });
    }
}
